import { useId, type ReactNode } from 'react';
import s from './Field.module.css';

type FieldProps = {
  label: string;
  help?: string;
  error?: string;
  /**
   * Render-prop receiving the wiring a control needs for accessible labelling
   * + error association. Spread it onto the <input>/<textarea>.
   */
  children: (wiring: {
    id: string;
    'aria-invalid': boolean;
    'aria-describedby': string | undefined;
  }) => ReactNode;
};

export function Field({ label, help, error, children }: FieldProps) {
  const id = useId();
  const messageId = `${id}-msg`;
  const hasMessage = Boolean(error || help);

  return (
    <div className={s.field}>
      <label className={s.label} htmlFor={id}>
        {label}
      </label>
      {children({
        id,
        'aria-invalid': Boolean(error),
        'aria-describedby': hasMessage ? messageId : undefined,
      })}
      {error ? (
        <span id={messageId} className={s.error} role="alert">
          {error}
        </span>
      ) : help ? (
        <span id={messageId} className={s.help}>
          {help}
        </span>
      ) : null}
    </div>
  );
}
